import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addTopUp } from "@/services/subscription.service";

export const useAddTopUp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (amount: number) => addTopUp(amount),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
    },
  });
};
